import type {
    BookingWorkHours,
    BookingWorkHoursInput,
    BookingsWorkTimeSlot,
} from 'owa-graph-schema';
import mapToBookingWorkTimeSlotInput from './mapToBookingWorkTimeSlotInput';

const mapToBookingWorkHoursInput = (businessHours: BookingWorkHours[]): BookingWorkHoursInput[] => {
    const modifiedBusinessHours: BookingWorkHoursInput[] = businessHours?.map(businessHour => {
        return {
            day: businessHour.day,
            timeSlots: mapToBookingWorkTimeSlotInput(
                businessHour.timeSlots as BookingsWorkTimeSlot[]
            ),
        };
    });
    return modifiedBusinessHours;
};

export default mapToBookingWorkHoursInput;
